module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "nav_section",
    attrs: {
      "id": "header_scroll"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "menu_bar clearfix"
  }, [_c('div', {
    staticClass: "menu_contact"
  }, [_c('div', {
    staticClass: "trigger_contact",
    attrs: {
      "onclick": "mylocationntoggle()"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  }), (_vm.props.acf.get_in_touch_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.get_in_touch_text)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "trigger_dropdown",
    attrs: {
      "id": "requestshow"
    }
  }, [_c('div', {
    staticClass: "menu_location"
  }, [(_vm.props.acf.getintouch_location_5_title) ? _c('div', {
    staticClass: "menu_locationname",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.getintouch_location_5_title)
    }
  }) : _vm._e(), (_vm.props.acf.getintouch_location_5_phone) ? _c('a', {
    staticClass: "menu_locationphone",
    attrs: {
      "href": "tel:" + _vm.props.acf.getintouch_location_5_phone,
      "itemprop": "telephone"
    }
  }, [_vm._m(0), (_vm.props.acf.getintouch_location_5_phone) ? _c('span', {
    staticClass: "phonenumber",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.getintouch_location_5_phone)
    }
  }) : _vm._e()]) : _vm._e(), (_vm.props.acf.getintouch_location_5_text) ? _c('a', {
    staticClass: "menu_locationtext",
    attrs: {
      "href": "sms:" + _vm.props.acf.getintouch_location_5_text,
      "itemprop": "mobile"
    }
  }, [_vm._m(1), (_vm.props.acf.getintouch_location_5_text) ? _c('span', {
    staticClass: "phonenumber",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.getintouch_location_5_text)
    }
  }) : _vm._e()]) : _vm._e(), _c('span', {
    staticClass: "menu_location-address clickbtn",
    on: {
      "click": function($event) {
        return _vm.contactLocation4()
      }
    }
  }, [_vm._m(2), (_vm.props.acf.getintouch_location_5_address) ? _c('address', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.getintouch_location_5_address)
    },
    on: {
      "click": function($event) {
        return _vm.contactLocation0()
      }
    }
  }) : _vm._e()])])])]), _c('div', {
    staticClass: "menu_logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [(_vm.props.acf.logo_full) ? _c('img', {
    staticClass: "logofull",
    attrs: {
      "src": _vm.props.acf.logo_full,
      "alt": "logo full"
    }
  }) : _vm._e(), (_vm.props.acf.logo) ? _c('img', {
    staticClass: "logohalf",
    attrs: {
      "src": _vm.props.acf.logo,
      "alt": "logo half"
    }
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "menu_right"
  }, [_c('div', {
    staticClass: "toggle_menu",
    attrs: {
      "id": "togglemenubtn",
      "onclick": "mymenutoggle()"
    }
  }, [(_vm.props.acf.menu_text) ? _c('div', {
    staticClass: "toogle_menutext",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.menu_text)
    }
  }) : _vm._e(), _vm._m(3)]), _c('div', {
    staticClass: "toggle_menudropdown",
    attrs: {
      "id": "manualmenutoggle",
      "onclick": "mymenutoggleclose()"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('router-link', {
    staticClass: "homeicon",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('div', {
    staticClass: "menu_wrapp clearfix"
  }, [_c('ul', {
    staticClass: "nav_menuu clearfix"
  }, [_c('li', {
    staticClass: "parentlist",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.menu_1_bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "nav_parent-link-overlay"
  }), _c('div', {
    staticClass: "nav_parent-link"
  }, [_c('router-link', {
    staticClass: "root_link",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/about-us"
    }
  }, [_c('span', [_vm._v("About Us")])])], 1), _c('ul', {
    staticClass: "nav_sub-nav"
  }, [_c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection1()
      }
    }
  }, [_c('span', [_vm._v("Dr. Aaron Havens")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection3()
      }
    }
  }, [_c('span', [_vm._v("Our Promise ")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection5()
      }
    }
  }, [_c('span', [_vm._v("What Sets Us Apart")])])])])]), _c('li', {
    staticClass: "parentlist",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.menu_2_bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "nav_parent-link-overlay"
  }), _c('div', {
    staticClass: "nav_parent-link"
  }, [_c('router-link', {
    staticClass: "root_link",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/new-patients"
    }
  }, [_c('span', [_vm._v("New Patients")])])], 1), _c('ul', {
    staticClass: "nav_sub-nav"
  }, [_c('li', [(_vm.props.acf.covid_url) ? _c('a', {
    staticClass: "innerlink",
    attrs: {
      "href": _vm.props.acf.covid_url,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("COVID-19 Patient Screening Form")])]) : _vm._e()]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection1()
      }
    }
  }, [_c('span', [_vm._v("Your First Visit")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection2()
      }
    }
  }, [_c('span', [_vm._v("Patient Forms")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection3()
      }
    }
  }, [_c('span', [_vm._v("Invisalign")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection4()
      }
    }
  }, [_c('span', [_vm._v("iTero")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection5()
      }
    }
  }, [_c('span', [_vm._v("Clear Braces                          ")])])])])]), _c('li', {
    staticClass: "parentlist",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.menu_3_bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "nav_parent-link-overlay"
  }), _c('div', {
    staticClass: "nav_parent-link"
  }, [_c('router-link', {
    staticClass: "root_link",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/our-patient-is-you"
    }
  }, [_c('span', [_vm._v("Our Patient Is You")])])], 1), _c('ul', {
    staticClass: "nav_sub-nav"
  }, [_c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection2()
      }
    }
  }, [_c('span', [_vm._v("No Later Than Age 7")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection3()
      }
    }
  }, [_c('span', [_vm._v("Adult Treatment")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection4()
      }
    }
  }, [_c('span', [_vm._v("Care For Braces")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection1()
      }
    }
  }, [_c('span', [_vm._v("Smile Gallery")])])]), _c('li', [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection5()
      }
    }
  }, [_c('span', [_vm._v("Helpful Videos")])])])])]), _c('li', {
    staticClass: "parentlist",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.menu_4_bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "nav_parent-link-overlay"
  }), _c('div', {
    staticClass: "nav_parent-link"
  }, [_c('router-link', {
    staticClass: "root_link",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Contact Us")])])], 1), _c('ul', {
    staticClass: "nav_sub-nav"
  }, [_c('li', [(_vm.props.acf.online_bill_pay) ? _c('a', {
    staticClass: "innerlink",
    attrs: {
      "href": _vm.props.acf.online_bill_pay,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Online Bill Pay")])]) : _vm._e()])])])])])], 1)]), _c('div', {
    staticClass: "mobile-nav-manual"
  }, [_c('div', {
    staticClass: "mobile_menu",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_vm._m(4), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/about-us"
    }
  }, [_vm._v("About Us")]), _vm._m(5), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-1"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection1()
      }
    }
  }, [_c('span', [_vm._v("Dr. Aaron Havens")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection3()
      }
    }
  }, [_c('span', [_vm._v("Our Promise ")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.aboutsection5()
      }
    }
  }, [_c('span', [_vm._v("What Sets Us Apart")])])])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/new-patients"
    }
  }, [_vm._v("New Patients")]), _vm._m(6), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-2"
    }
  }, [_c('li', [(_vm.props.acf.covid_url) ? _c('a', {
    staticClass: "innerlink",
    attrs: {
      "href": _vm.props.acf.covid_url,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("COVID-19 Patient Screening Form")])]) : _vm._e()]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection1()
      }
    }
  }, [_c('span', [_vm._v("Your First Visit")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection2()
      }
    }
  }, [_c('span', [_vm._v("Patient Forms")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection3()
      }
    }
  }, [_c('span', [_vm._v("Invisalign")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection4()
      }
    }
  }, [_c('span', [_vm._v("iTero")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.newpatientsection5()
      }
    }
  }, [_c('span', [_vm._v("Clear Braces ")])])])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/our-patient-is-you"
    }
  }, [_vm._v("Our Patient Is You")]), _vm._m(7), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-3"
    }
  }, [_c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection2()
      }
    }
  }, [_c('span', [_vm._v("No Later Than Age 7")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection3()
      }
    }
  }, [_c('span', [_vm._v("Adult Treatment")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection4()
      }
    }
  }, [_c('span', [_vm._v("Care For Braces")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection1()
      }
    }
  }, [_c('span', [_vm._v("Smile Gallery")])])]), _c('li', {
    attrs: {
      "onclick": "closeNav()"
    }
  }, [_c('span', {
    staticClass: "innerlink",
    on: {
      "click": function($event) {
        return _vm.ourpatientsection5()
      }
    }
  }, [_c('span', [_vm._v("Helpful Videos ")])])])])], 1), _c('li', [_c('router-link', {
    staticClass: "header-nav-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact Us")]), _vm._m(8), _c('ul', {
    staticClass: "sub_menuu",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "subMenu-4"
    }
  }, [_c('li', [(_vm.props.acf.online_bill_pay) ? _c('a', {
    staticClass: "innerlink",
    attrs: {
      "href": _vm.props.acf.online_bill_pay,
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Online Bill Pay")])]) : _vm._e()])])], 1)])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-contact_phone-icon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-contact_phone-icon"
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav_addressicon"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toogle_menuiconwrap",
    attrs: {
      "onclick": "openNav()"
    }
  }, [_c('div', {
    staticClass: "toogle_menuicon"
  }, [_c('span', {
    staticClass: "toggle-line"
  }), _c('span', {
    staticClass: "toggle-line"
  }), _c('span', {
    staticClass: "toggle-line"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "closebtn idw-icon-close",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "closeNav()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(1)",
      "id": "toggleClass-1"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(2)",
      "id": "toggleClass-2"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(3)",
      "id": "toggleClass-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "subMenu_open",
    attrs: {
      "onclick": "subMenu(4)",
      "id": "toggleClass-4"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-273ac6b8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/header/header.pug
// module id = 515
// module chunks = 1